import styled from 'styled-components';

export const StyledPostsSection = styled.section`
  & > h3 {
    font-size: ${({ theme }) => theme.fontSizes.h3.m};
    font-weight: ${({ theme }) => theme.fontWeights[4]};
    margin: 20px 0;
  }

  .posts-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: start;
    margin-left: -20px;
  }
`;